import React from "react";

export default () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="ic_check_circle_48px" clip-path="url(#clip0_1252_135158)">
                <path
                    id="Vector"
                    d="M12 2C6.475 2 2 6.475 2 12C2 17.52 6.475 22 12 22C17.52 22 22 17.52 22 12C22 6.475 17.52 2 12 2ZM10 17L5 12L6.415 10.585L10 14.17L17.585 6.585L19 8L10 17Z"
                    fill="#36B37E"
                />
            </g>
            <defs>
                <clipPath id="clip0_1252_135158">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
